<template>
  <div class="competitor-pagination-wrap">
    <div class="left-wrap">
      <!-- <span>共{{total}}条记录 每页显示</span> -->
      <span>每页显示</span>
      <ASelect class="pagination-select" :instance="pageList" @change="pageSizeChange"></ASelect>条
    </div>
    <span class="right-wrap pagination-wrap">
      <a-pagination
        ref="pagination"
        v-model="currentPage" 
        :total="total" 
        :default-current="1" 
        :page-size="pageSize"
        :item-render="itemRender" 
        show-quick-jumper 
        @change="pageChange"/>
      <!-- <a-button class="pagination-btn" @click="jumpToPage">确定</a-button> -->
    </span>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ASelect from '@/views/backstageSupport/components/formTable/components/ASelect'

export default {
  props:{
    paginationOpt:Object
  },
  data() {
    return {
      total: 0,
      currentPage: 1,
      pageSize: 10,
      pageList: {
        defaultValue: 10,
        list: [
          { label: 10, value: 10 },
          { label: 20, value: 20 },
          { label: 30, value: 30 },
          { label: 40, value: 40 },
        ]
      }
    }
  },
  watch: {
    paginationOpt:{
      handler(nVal) {
        this.total = nVal.total // 只需要更新总数
        // Object.assign(this, {...this.paginationOpt})
      },
      deep: true,
      immediate: true
    },
    getSearchExper: {
      handler() {
        this.pageList.defaultValue = 10
        this.currentPage = 1
        this.emitChangeEvent()
      },
      deep: true
    }
  },
  components: {
    ASelect
  },
  computed:{
    ...mapGetters('filterGroup', [
      'getSearchExper'
    ])
  },
  methods:{
    itemRender(current, type, originalElement) {
      if (type === 'prev') {
        return <div>
          <a-button class="no-r" onClick={this.prePage}>上一页</a-button>
        </div>
      } if (type === 'next') {
        return <div>
          <a-button class="no-l" onClick={this.nextPage}>下一页</a-button>
        </div>
      }
      return originalElement
    },
    pageSizeChange(pageSize) {
      this.pageSize = pageSize
      this.currentPage = 1
      this.emitChangeEvent()
    },
    prePage() {
      if(this.currentPage === 1) return
      this.emitChangeEvent()
    },
    nextPage() {
      const maxPage = Math.ceil(Number(this.total) / Number(this.pageSize))
      if(this.currentPage === maxPage) return
      this.emitChangeEvent()
    },
    pageChange(page) {
      this.currentPage = page
      this.emitChangeEvent()
    },
    jumpToPage() {
    },
    emitChangeEvent() {
      const {pageSize, currentPage} = this
      this.$emit('change', {
        page: currentPage,
        pageSize
      })
    }
  }
}
</script>
